import { render } from "./BFormInvalidFeedback.vue?vue&type=template&id=095175eb"
import script from "./BFormInvalidFeedback.vue?vue&type=script&lang=js"
export * from "./BFormInvalidFeedback.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__